import React, { forwardRef, useImperativeHandle } from 'react';
import { IInboundCallBookingResData } from 'services/types/apt';
import { ICustomerUI } from 'types/customer';
import useCallerId from './useCallerId';
type ICallerContextRef = {
  onBook: (data: IInboundCallBookingResData) => void;
  onSMS: (data: IInboundCallBookingResData) => void;
};
export const callerContextRef = React.createRef<ICallerContextRef>();
const CallerContextUI = forwardRef<ICallerContextRef>((_, ref) => {
  const services = useCallerId();

  const handleBookFromNative = (data: IInboundCallBookingResData) => {
    const customer: ICustomerUI = { id: data.customerId, name: data.customerName || '', phone: data.phone };
    services.book(data.callerId, customer);
  };

  const handleSMSFromNative = (data: IInboundCallBookingResData) => {
    const customer: ICustomerUI = { id: data.customerId, name: data.customerName || '', phone: data.phone };
    services.sms(data.callerId, customer);
  };

  useImperativeHandle(ref, () => ({
    onBook: handleBookFromNative,
    onSMS: handleSMSFromNative,
  }));

  return <></>;
});

const CallerContextProvider = () => {
  return (
    <CallerContextUI ref={callerContextRef} />
  );
};

const CallerContext = {
  onBook: (data: IInboundCallBookingResData) => callerContextRef.current?.onBook?.(data),
  onSMS: (data: IInboundCallBookingResData) => callerContextRef.current?.onSMS?.(data),
};

export { CallerContextProvider };
export default CallerContext;
